import config from 'config';

const getRibUrl = (bankAccountId: string, language: string): string =>
  `${config.shineApiHost}/export/bankAccounts/${bankAccountId}/rib/pdf?lang=${language}`;

export default getRibUrl;
